import React from 'react';
import Input from '../common/Input';
import Label from '../common/Label';
import Dropdown from '../common/Dropdown';
import Button from '../common/Button';
import ErrorMessage from '../common/ErrorMessage';
import { USER_ROLES_OPTIONS } from '../../constants';
import useInviteForm from '../../hooks/useInviteForm';

const InviteSection = () => {
  const {
    inviteEmail,
    setInviteEmail,
    selectedRole,
    setSelectedRole,
    isLoadingInvite,
    errors,
    handleSubmit,
  } = useInviteForm();

  const isButtonDisabled = !inviteEmail || !selectedRole || isLoadingInvite;

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col items-center justify-center w-full sm:flex-row sm:space-x-6"
      >
        {/* Invitation Input */}
        <div className="flex flex-col w-full sm:w-64">
          <div className="relative min-h-[2rem] mb-6">
            <Label variant="dark">Email</Label>
            <Input
              variant="secondary"
              type="text"
              id="invite"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
              placeholder="Enter user's email"
            />
            <ErrorMessage message={errors?.email} />
          </div>
        </div>

        {/* Role Dropdown */}
        <div className="flex flex-col w-full sm:w-64">
          <div className="relative min-h-[2rem] mb-6">
            <Label variant="dark">Role</Label>
            <Dropdown
              options={USER_ROLES_OPTIONS}
              selectedOption={selectedRole?.label || ''}
              onSelect={setSelectedRole}
              text="Select user role"
            />
            <ErrorMessage message={errors?.role} />
          </div>
        </div>

        {/* Invite Button */}
        <div className="flex flex-col">
          <Button type="submit" variant="primary" disabled={isButtonDisabled}>
            {isLoadingInvite ? 'Inviting...' : 'Invite'}
          </Button>
        </div>
      </form>
    </>
  );
};

export default InviteSection;
